module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/pen-tool-vector-23bd0310ce13a3427181906cf9133490.svg";